/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Recorder_Start_FailedInputs */

const en_audio_recorder_start_failed = /** @type {(inputs: Audio_Recorder_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to start recording: ${i?.error}`)
};

const fr_audio_recorder_start_failed = /** @type {(inputs: Audio_Recorder_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec du démarrage de l'enregistrement : ${i?.error}`)
};

const de_audio_recorder_start_failed = /** @type {(inputs: Audio_Recorder_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aufzeichnung konnte nicht gestartet werden: ${i?.error}`)
};

const it_audio_recorder_start_failed = /** @type {(inputs: Audio_Recorder_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile avviare la registrazione: ${i?.error}`)
};

const ru_audio_recorder_start_failed = /** @type {(inputs: Audio_Recorder_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось начать запись: ${i?.error}`)
};

const es_audio_recorder_start_failed = /** @type {(inputs: Audio_Recorder_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al iniciar la grabación: ${i?.error}`)
};

const zh_cn2_audio_recorder_start_failed = /** @type {(inputs: Audio_Recorder_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`录制开始失败：${i?.error}`)
};

const ja_audio_recorder_start_failed = /** @type {(inputs: Audio_Recorder_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`録画を開始できませんでした: ${i?.error}`)
};

const hi_audio_recorder_start_failed = /** @type {(inputs: Audio_Recorder_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`रिकॉर्डिंग शुरू करने में विफल: ${i?.error}`)
};

const pt_pt2_audio_recorder_start_failed = /** @type {(inputs: Audio_Recorder_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao iniciar a gravação: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to start recording: {error}" |
*
* @param {Audio_Recorder_Start_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_start_failed = /** @type {((inputs: Audio_Recorder_Start_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Start_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_start_failed(inputs)
	if (locale === "de") return de_audio_recorder_start_failed(inputs)
	if (locale === "it") return it_audio_recorder_start_failed(inputs)
	if (locale === "ru") return ru_audio_recorder_start_failed(inputs)
	if (locale === "es") return es_audio_recorder_start_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_start_failed(inputs)
	if (locale === "ja") return ja_audio_recorder_start_failed(inputs)
	if (locale === "hi") return hi_audio_recorder_start_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_start_failed(inputs)
	return en_audio_recorder_start_failed(inputs)
});